module.exports = __webpack_public_path__ + "images/img_4.png";